// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";
import { ShellContext } from "@insite/client-framework/Components/IsInShell";
import { menuSecondaryNavigationItemStyles } from "@store/Themes/common/mixins/menu";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import React, { FC, useContext, useMemo } from "react";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";

export interface NavigationWrapperStyles {
    wrapper?: InjectableCss;
    innerWrapper?: InjectableCss;
    section?: InjectableCss;
    hidden?: HiddenProps;
}

export const navigationWrapperStyles: NavigationWrapperStyles = {
    wrapper: {
        css: css`
            position: relative;
            z-index: 1;
            ${x => breakpointValues(x.theme.design.menu.secondaryNavigation.height, "height")}
            color: ${getColor("text")};
            line-height: ${x => x.theme.design.typography.lineHeight.semi};

            ${breakpoint("md")} {
                background-color: ${getColor("common.accent")};
            }
        `,
    },
    innerWrapper: {
        css: css`
            display: flex;
            justify-content: space-between;
            height: inherit;
            ${breakpoint("md")} {
                margin-right: ${pxToRem(30)};
            }
        `,
    },
    section: {
        css: css`
            display: flex;
            align-items: center;
            flex-shrink: 0;

            ${({ theme }) =>
                breakpointValues(
                    theme.design.menu.secondaryNavigation.itemSpacing.map(x => (x !== null ? `calc(${x} / 2)` : null)),
                    ["margin-right", "margin-left"],
                )}

            > [class^="Wrapper-"] /* Zone */ {
                ${menuSecondaryNavigationItemStyles()}
                display: flex;
                align-items: center;
                width: auto;
            }

            &:first-child {
                margin-left: 0;
            }

            &:last-child {
                margin-right: 0;

                ${breakpoint("sm", "down")} {
                    margin-left: 0;
                }
            }
        `,
    },
    hidden: {
        below: "md",
        css: css`
            > div {
                display: flex;
            }
        `,
    },
};
const styles = navigationWrapperStyles;

const NavigationWrapper: FC<WidgetProps> = ({ id }) => {
    const { isEditing, isInShell } = useContext(ShellContext);

    const wrapperCss = useMemo(() => {
        return css`
            ${styles.wrapper?.css}
            ${isEditing ? "height: auto;" : null}
            ${!isEditing && isInShell ? "[data-widget] { height: 100%; }" : null}
        `;
    }, [styles, isEditing, isInShell]);

    return (
        <StyledWrapper {...styles.wrapper} css={wrapperCss}>
            <StyledWrapper className="wrapper" {...styles.innerWrapper}>
                <StyledWrapper className="zone-left" {...styles.section}>
                    <Zone zoneName="Left" contentId={id} />
                </StyledWrapper>
                <StyledWrapper className="zone-right" {...styles.section}>
                    <Hidden {...styles.hidden}>
                        <Zone zoneName="Right" contentId={id} />
                    </Hidden>
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const navigationWrapper: WidgetModule = {
    component: NavigationWrapper,
    definition: {
        group: "Common",
        icon: "link-simple",
    },
};

export default navigationWrapper;
